<div class="mct-flex mct-row mct-justify-center mct-items-stretch">
  <div class="mct-flex mct-col mct-justify-between mct-items-stretch">
    <div class="mct-flex mct-row mct-justify-between mct-items-stretch">
      <div>{{ 'reports.query-tool.view-results.query-results' | translate | titlecase }}</div>
      <button pButton type="button" (click)="openSaveDialog()" class="atlas-btn atlas-btn-primary">
        {{ 'reports.query-tool.save-query.save-query-definition' | translate | titlecase }}
      </button>
    </div>

    <div class="mt-30" style="width: 80vw">
      <p-table [showGridlines]="true" [columns]="columnNames" [value]="searchResult.Result" [paginator]="true" [rows]="searchResult.PageSize"
        [totalRecords]="queryResults.length" (onLazyLoad)="lazyLoad($event)" [tableStyle]="{ width: 'max-content' }"
        [lazy]="true">
        <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
          <SortAltIcon *ngIf="sortOrder === 0">
            <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
          </SortAltIcon>
          <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
            <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
          </SortAmountUpAltIcon>
          <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
            <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
          </SortAmountDownIcon>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let column of columnNames" [pSortableColumn]="column" style="max-width: 600px">
              {{ column }} <p-sortIcon></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-queryResult let-columns="columns">
          <tr>
            <td *ngFor="let column of columns" style="max-width: 600px">
              <span *ngIf="fieldTypes[column] != 'date'"> {{ queryResult[column] }}</span>
              <span *ngIf="fieldTypes[column] == 'date'"> {{ queryResult[column] | date : 'MM/dd/yyyy' }}</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft"> </ng-template>
        <ng-template pTemplate="paginatorright">
          {{ 'reports.query-tool.view-results.record-count' | translate | titlecase }}: {{ totalCount }}
          <span *ngIf="totalCount > 1000">
            <strong>({{ 'reports.query-tool.view-results.displaying-top-1000' | translate }})</strong>
          </span>
        </ng-template>
      </p-table>
      <p-progressSpinner *ngIf="loading"></p-progressSpinner>
      <wl-page-size-dropdown [(pageSize)]="searchParams.PageSize" [pageSizes]="[20, 100, 0]"
        (pageSizeChange)="pageSizeChanged()"></wl-page-size-dropdown>
    </div>
  </div>
</div>
<div class="mt-20 mr-25 mct-flex mct-row mct-justify-end mct-items-stretch">
  <button pButton type="button" [disabled]="exporting" (click)="exportResults()" class="btn atlas-btn-secondary">
    {{ 'reports.query-tool.view-results.export-results' | translate | uppercase }} <wl-busy
      [show]="exporting"></wl-busy>
  </button>
  <button pButton type="button" (click)="openProfileSelector()" class="btn atlas-btn-secondary">
    {{ 'reports.query-tool.view-results.open-results' | translate | uppercase }}
  </button>
</div>
<wl-query-tool-save-query-modal></wl-query-tool-save-query-modal>
